<div class="task-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          {{action}}
        </span>
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Trabajo
        </span>
        <span class="status-pill status-label"
          [ngStyle]="{'background-color': taskStatusColors[f['status'].value ?? 'DEFAULT'] || taskStatusColors.DEFAULT}"
          *ngIf="action !== 'Crear' && f?.['status']">
          {{taskStatuses[f['status'].value ?? '']}}
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-6 text-primary text-left py-0">
        <div *ngIf="task.quote?.number">
          Generado desde Presupuesto Nro:
          {{ task.quote?.number }}
        </div>
        <span *ngIf="task.deliverynote?.serieAndNumber">
          Incluida en ALBARAN
          {{ task.deliverynote.serieAndNumber}}
        </span>
      </div>

      <div class="col-6 text-primary text-right py-0 justify-self-end">
        <span *ngIf="invoice">
          Incluida en FACTURA
          {{ invoice.serieAndNumber || (invoice.docNumber ? "# " + invoice.docNumber : (invoice.number ? "# " +
          invoice.number : '')) }}
          <span *ngIf="invoice.details && invoice.details.length > 1">. Contiene items adicionales.</span>
        </span>
      </div>
    </div>
    <div class="row" *ngIf="!loading">
      <div class="col-12">
        <div class="row">
          <div class="task-content col-md-12 pt-2" [ngClass]="{darken: readOnly}" (click)="setEditable()">

            <div class="row">

              <!-- Cliente -->
              <div class="col-12 col-md-5">
                <div class="row">
                  <div class="col-10">
                    <mat-form-field appearance="outline">
                      <mat-label>
                        Cliente
                        <span *ngIf="!(clientsTerm?.length || f['client']?.value)">(Escribe para buscar...)</span>
                      </mat-label>
                      <input matInput type="text" name="client" formControlName="client" [matAutocomplete]="autoClient"
                        [readonly]="readOnly || task.status === 'INVOICED'">
                      <mat-autocomplete #autoClient="matAutocomplete" [displayWith]="displayClientsFn"
                        (optionSelected)="newClientSelected($event.option.value)" required>
                        <mat-option *ngFor="let client of $clients | async" [value]="client">
                          {{client.firstname}} {{client.lastname ? client.lastname : ''}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['client']?.errors?.['required']">
                      Cliente Obligatorio
                    </mat-error>
                    <mat-error *ngIf="submitted && f['client']?.errors?.['notFound']">
                      Cliente NO Encontrado (Agregar Nuevo?)
                    </mat-error>
                  </div>
                  <div class="col-2 pt-2 pl-0">
                    <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewClientModal()">
                      <i class="material-icons">add</i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- category -->
              <div class="col-12 col-md-4 ml-auto">
                <div class="row">
                  <div class="col-10">
                    <mat-form-field appearance="outline">
                      <mat-label> Categoría </mat-label>
                      <mat-select name="category" formControlName="category"
                        [ngClass]="{ 'is-invalid': submitted && f['category'].errors }">
                        <mat-option *ngFor="let category of categories"
                          [value]="category._id">{{category.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['category']?.errors?.['required']">
                      Categoría Obligatoria
                    </mat-error>
                  </div>
                  <div class="col-2 pt-2 pl-0">
                    <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewCategoryModal()">
                      <i class="material-icons">add</i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- status -->
              <!--div class="col-md-3">
                <div class="status"
                  [ngStyle]="{'background-color': taskStatusColors[f.status.value] || taskStatusColors.DEFAULT}">
                  {{taskStatuses[f.status.value]}}
                </div>
              </div-->
            </div>

            <div class="row">

              <div class="col-md-6">
                <div class="row">

                  <!-- title -->
                  <div class="col-12 pb-0 mb-0">
                    <mat-form-field appearance="outline" class="pb-0 mb-0">
                      <mat-label> Título </mat-label>
                      <input matInput name="title" formControlName="title" type="text"
                        [readonly]="readOnly  || task.status === 'INVOICED'">
                    </mat-form-field>
                  </div>

                  <!-- description -->
                  <div class="col-12 pt-0 mt-0 description-field">
                    <mat-form-field appearance="outline" class="pt-0 mt-0">
                      <textarea matInput placeholder="Instrucciones (Serán visibles para tu personal en la app móvil)"
                        name="description" formControlName="description"
                        [readonly]="readOnly  || task.status === 'INVOICED'" style="height: 70px !important;"
                        [ngClass]="{ 'is-invalid': submitted && f['description'].errors }">
                      </textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">

                  <!-- location -->
                  <div class="col-12 field-container">
                    <mat-form-field appearance="outline">
                      <mat-label>
                        Ubicación:
                        <span *ngIf="f['latitude']?.value && f['longitude']?.value">
                          (lat: {{f['latitude'].value | number:'1.6-6'}} / long: {{f['longitude'].value |
                          number:'1.6-6'}})
                        </span>
                      </mat-label>
                      <input matInput name="location" formControlName="location" type="text"
                        [readonly]="true || task.status === 'INVOICED'"
                        [ngClass]="{ 'is-invalid': submitted && f['location'].errors }"
                        (click)="!(task.status == 'INVOICED') && !(task.status == 'CANCELLED') && openGetLocationModal()"
                        class="cursor-pointer">
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['location']?.errors?.['required']">
                      Ubicación Obligatoria
                    </mat-error>
                    <mat-error *ngIf="submitted && f['location']?.errors?.['fromMap']">
                      Ubicación no seleccionada desde mapa
                    </mat-error>

                    <span class="field-actions">
                      <button type="button" class="btn btn-link text-manax p-0 m-0 btn-new-input"
                        (click)="!(task.status == 'INVOICED') && !(task.status == 'CANCELLED') && openGetLocationModal()">
                        <i class="material-icons">place</i>
                      </button>
                    </span>
                  </div>

                  <!-- workers -->
                  <div class="col-12 field-container pt-5">
                    <mat-form-field appearance="outline">
                      <mat-label>
                        Trabajadores
                      </mat-label>
                      <mat-select name="workers" formControlName="workers" multiple>
                        <mat-option *ngFor="let worker of workers" [value]="worker._id">{{worker.firstname}}
                          {{worker.lastname}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span class="field-actions">
                      <button type="button" class="btn btn-link text-success ml-0 mr-4 p-1"
                        (click)="openWorkersWhatsapp();$event.stopPropagation()" *ngIf="f['workers'].value?.length > 0">
                        <i class="fa fa-whatsapp mr-1"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row"> <!--*ngIf="formLevel >= 50"-->

              <div class="col-12">
                <h5 class="m-0 pt-3 title-section">
                  Tipo
                  <a [matMenuTriggerFor]="helpTipoDialog" (click)="$event.stopPropagation()">
                    <i class="material-icons" style="font-size: 18px; color: #000; cursor: pointer;">help</i>
                  </a>

                  <mat-menu #helpTipoDialog="matMenu"
                    class="py-0 px-3 d-flex justify-content-center align-items-center">
                    <ng-container>
                      <span><b class="bold-item">¿Necesitas Ayuda?</b></span><br>
                      <span><b class="bold-item">Trabajo Eventual:</b> Selecciona esta opción si deseas que se realice
                        un
                        único trabajo en una fecha específica.</span><br>
                      <span><b class="bold-item">Trabajo Recurrente:</b> Elige esta opción si prefieres que los trabajos
                        se realicen de forma periódica según las reglas que determines.</span>
                    </ng-container>
                  </mat-menu>
                </h5>
              </div>

              <!-- type y task duration -->
              <div class="col-md-6">
                <div class="row">

                  <div class="col-12 mb-2" *ngIf="scheduling">

                    <mat-menu #menu="matMenu" class="py-0 px-3 d-flex justify-content-center align-items-center">
                      <ng-container>
                        <span>Los Trabajos Eventuales tienen un final determinado y se facturan a través de una única
                          factura. Los
                          Trabajos Recurrentes se repiten periódicamente y pueden facturarse a través de múltiples
                          facturas.</span>
                      </ng-container>
                    </mat-menu>
                  </div>
                </div>

                <div class="row mb-3">
                  <div
                    class="col-6 col-md-6 col-lg-4 recurring-task-tab cursor-pointer p-1 text-center bordered-element-unique"
                    (click)="setRecurringTask(false)" [ngClass]="{'tab-active': !recurringTask}"
                    *ngIf="scheduling && taskRequest">
                    <h5 [ngClass]="{'text-default': !recurringTask, 'text-gray': recurringTask}"
                      style="margin: 0 !important;">
                      Trabajo <span>Eventual</span>
                    </h5>
                  </div>

                  <div
                    class="col-6 col-md-6 col-lg-4 recurring-task-tab cursor-pointer p-1 text-center bordered-element"
                    (click)="setRecurringTask(false)" [ngClass]="{'tab-active': !recurringTask}"
                    *ngIf="scheduling && !taskRequest">
                    <h5 [ngClass]="{'text-default': !recurringTask, 'text-gray': recurringTask}"
                      style="margin: 0 !important;">
                      Trabajo <span>Eventual</span>
                    </h5>
                  </div>

                  <div
                    class="col-6 col-md-6 col-lg-4 recurring-task-tab cursor-pointer p-1 text-center bordered-element-right"
                    (click)="setRecurringTask()" [ngClass]="{'tab-active': recurringTask}"
                    *ngIf="scheduling && !taskRequest">
                    <h5 [ngClass]="{'text-default': recurringTask, 'text-gray': !recurringTask}"
                      style="margin: 0 !important;">
                      Trabajo Recurrente
                    </h5>
                  </div>

                  <div class="col-8 p-2" *ngIf="!scheduling">
                    <h4 *ngIf="haveRecurrence" style="color: #000; margin: 0 !important;">
                      <i class="material-icons" style="font-size: 18px;">event_repeat</i>
                      Frecuencia: {{recuFreq}}

                      <a [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                        *ngIf="haveRecurrence && untilDate">
                        <i class="material-icons"
                          style="font-size: 18px; color: #5B5D5B; cursor: pointer;">info_outlined</i>
                      </a>

                      <mat-menu #menu="matMenu" class="py-0 px-3 d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="untilDate">
                          <span *ngIf="recuDay && !recuInterval">Los {{recuDay}} de cada mes <br></span>
                          <span *ngIf="recuDay && recuInterval">Los días {{recuDay}} cada {{recuInterval}} meses
                            <br></span>
                          <span *ngIf="recuWeek && !recuInterval">{{ recuWeek.join(', ') }} todas las semanas<br></span>
                          <span *ngIf="recuWeek && recuInterval">{{ recuWeek.join(', ') }} cada {{recuInterval}}
                            semanas<br></span>
                          <span> Hasta: {{untilDate}}</span>
                        </ng-container>
                      </mat-menu>
                    </h4>
                  </div>
                </div>

                <div class="row">

                  <!-- date start -->
                  <div class="col-md-6 col-lg-4 pb-3">
                    <mat-form-field appearance="outline">
                      <mat-label *ngIf="!this.recurringTask"> Fecha y Hora de Inicio </mat-label>
                      <mat-label *ngIf="this.recurringTask"> Inicio Primer Trabajo </mat-label>
                      <input matInput name="scheduledStart" formControlName="scheduledStart" class="d-flex"
                        style="line-height: 11px;" (ngModelChange)="scheduledStartChange()" type="date" #dobInput
                        [readonly]="readOnly || !showStart || task.status === 'INVOICED'">
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['scheduledStart']?.errors?.['required']">
                      Indicar fecha
                    </mat-error>
                    <mat-form-field appearance="outline">
                      <mat-label> Hora inicio </mat-label>
                      <input matInput appTimeMask formControlName="startTime"
                        [readonly]="readOnly || !showStart || task.status === 'INVOICED'"><!--[formControl]="startTime" -->
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['startTime']?.errors?.['required']">
                      Indicar hora
                    </mat-error>
                    <mat-error *ngIf="f['scheduledStart']?.errors?.['tooEarly']">
                      La fecha es muy antigua
                    </mat-error>
                    <mat-error *ngIf="f['scheduledStart']?.errors?.['bothRequired']">
                      Ambas fechas requeridas
                    </mat-error>
                  </div>

                  <!-- date end -->
                  <div class="col-md-6 col-lg-4 pb-3">
                    <mat-form-field appearance="outline">
                      <mat-label *ngIf="!this.recurringTask"> Fecha y Hora de Fin </mat-label>
                      <mat-label *ngIf="this.recurringTask"> Final Primer Trabajo </mat-label>
                      <input matInput name="scheduledEnd" formControlName="scheduledEnd"
                        class="d-flex justify-content-start " style="line-height: 11px;" type="date" #dobInput
                        [readonly]="readOnly || !showEnd || task.status === 'INVOICED'">
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['scheduledEnd'].errors?.['required']">
                      Indicar fecha
                    </mat-error>
                    <mat-form-field appearance="outline">
                      <mat-label> Hora fin </mat-label>
                      <input matInput appTimeMask formControlName="endTime"
                        [readonly]="readOnly || !showEnd || task.status === 'INVOICED'">
                    </mat-form-field>
                    <mat-error *ngIf="submitted && f['endTime']?.errors?.['required']">
                      Indicar hora
                    </mat-error>
                    <mat-error *ngIf="f['scheduledEnd']?.errors?.['lowerThanStart']">
                      La fecha es menor al Inicio
                    </mat-error>
                    <mat-error *ngIf="f['scheduledEnd']?.errors?.['bothRequired']">
                      Ambas fechas requeridas
                    </mat-error>
                    <!--mat-error *ngIf="f.scheduledEnd?.errors?.moreThan24Horus && !this.recurringTask">
                      Para programar trabajos con duración mayor a 1 día, debes seleccionar Trabajo Recurrente
                    </mat-error>
                    <mat-error *ngIf="f.scheduledEnd?.errors?.moreThan24Horus && this.recurringTask">
                      Para programar trabajos con duración mayor a 1 día, debes seleccionar su frecuencia de
                      repetición
                    </mat-error-->
                  </div>
                </div>
              </div>

              <div class="col-md-6 p-1" *ngIf="action !== 'Crear' && showUpdateUntilDate">
                <div class="row">
                  <div class="col-md-6 pb-3 pt-5">
                    <mat-form-field appearance="outline">
                      <mat-label> Fecha fin de recurencia </mat-label>
                      <input matInput name="updateUntilRecurrence" formControlName="updateUntilRecurrence"
                        class="d-flex" style="line-height: 11px;" type="date" #dobInput
                        [readonly]="readOnly || !showEnd || task.status === 'INVOICED'">
                    </mat-form-field>
                    <mat-error *ngIf="f['updateUntilRecurrence']?.errors?.['lowerDate']">
                      Fecha menor a la anterior
                    </mat-error>
                  </div>
                </div>
              </div>

              <!-- recurrence options -->
              <div class="col-md-6 p-1 border-recurrence" *ngIf="recurringTask">
                <div class="row">

                  <ng-container *ngIf="recurringTask">
                    <div class="col-md-5">
                      <mat-form-field appearance="outline">
                        <mat-label>
                          Repetir
                        </mat-label>
                        <mat-select name="recurringFrequency" formControlName="recurringFrequency"
                          (selectionChange)="recurringFrequencyChange()">
                          <mat-option [value]="-1">Nunca</mat-option>
                          <mat-option [value]="frequency.DAILY">Diariamente</mat-option>
                          <mat-option [value]="frequency.WEEKLY">Semanalmente</mat-option>
                          <mat-option [value]="frequency.MONTHLY">Mensualmente</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-md-7">
                      <div class="row">
                        <div class="col-5">
                          <mat-form-field appearance="outline" *ngIf="f['recurringFrequency'].value >= 0">
                            <mat-label>Cada</mat-label>
                            <input type="number" matInput name="recurringInterval" formControlName="recurringInterval"
                              [readonly]="readOnly || task.status === 'INVOICED'">
                          </mat-form-field>
                        </div>
                        <div class="col-7">
                          <span *ngIf="f['recurringFrequency'].value == frequency.DAILY">día(s) <br>
                            <span style="font-size: .7rem;line-height: 1; display: inline-block;">
                              El trabajo se repetirá todos los días, incluyendo sábados y domingos
                            </span>
                          </span>
                          <span *ngIf="f['recurringFrequency'].value == frequency.WEEKLY">semana(s)</span>
                          <span *ngIf="f['recurringFrequency'].value == frequency.MONTHLY">mes(es)</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5" *ngIf="f['recurringFrequency'].value == frequency.DAILY">
                      &nbsp;
                    </div>
                    <div class="col-md-5 text-right pt-0" *ngIf="f['recurringFrequency'].value == frequency.WEEKLY">
                      <span style="display: inline-block;">
                        <div class="wdays-label pt-0">Los días:</div>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px;"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[0]}" (click)="toggleRecWDay(0)">DO</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[1]}" (click)="toggleRecWDay(1)">LU</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[2]}" (click)="toggleRecWDay(2)">MA</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[3]}" (click)="toggleRecWDay(3)">MI</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[4]}" (click)="toggleRecWDay(4)">JU</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[5]}" (click)="toggleRecWDay(5)">VI</button>
                        <button type="button" class="btn p-1 m-0"
                          style="border: 1px solid gray; margin-right: 2px !important; min-width: 28px"
                          [ngClass]="{'btn-manax': f['recurringWDays'].value[6]}" (click)="toggleRecWDay(6)">SA</button>
                      </span>
                    </div>
                    <div class="col-md-5 text-right" *ngIf="f['recurringFrequency'].value == frequency.MONTHLY">
                      <mat-form-field appearance="outline">
                        <mat-label>El día del mes</mat-label>
                        <input type="number" matInput name="recurringMDay" formControlName="recurringMDay"
                          [readonly]="readOnly" required>
                      </mat-form-field>
                      <mat-error *ngIf="f['recurringMDay']?.errors?.['required']">
                        Indicar el día es Obligatorio
                      </mat-error>
                    </div>
                    <div class="col-md-7">
                      <div class="row">
                        <div class="col-5">
                          <mat-form-field appearance="outline" *ngIf="f['recurringFrequency'].value >= 0">
                            <mat-label>
                              Terminar
                            </mat-label>
                            <mat-select name="recurringEnd" formControlName="recurringEnd">
                              <mat-option value="ENDDATE">En</mat-option>
                              <mat-option value="ENDAFTER">Después de</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-7"
                          *ngIf="f['recurringEnd'].value === 'ENDDATE' && f['recurringFrequency'].value >= 0">
                          <mat-form-field appearance="outline">
                            <mat-label> Terminar en Día </mat-label>
                            <input matInput name="recurringUntil" formControlName="recurringUntil" class="d-flex"
                              style="line-height: 11px;" type="date"
                              [readonly]="readOnly  || task.status === 'INVOICED'">
                          </mat-form-field>
                          <mat-error *ngIf="f['recurringUntil']?.errors?.['required']">
                            Indicar fecha y hora
                          </mat-error>
                          <mat-error *ngIf="f['recurringUntil']?.errors?.['moreThanYear']">
                            Período máximo permitido: 1 año
                          </mat-error>
                        </div>
                        <div class="col-7"
                          *ngIf="f['recurringEnd'].value == 'ENDAFTER' && f['recurringFrequency'].value >= 0">
                          <mat-form-field appearance="outline">
                            <input matInput name="recurringCount" formControlName="recurringCount"
                              placeholder="Cantidad de Ocurrencias" type="number"
                              [readonly]="readOnly || task.status === 'INVOICED'">
                            <!-- <mat-error *ngIf="f.recurringCount?.errors?.limitRepetition">
                              No es posible repetir un trabajo más de 156 veces
                            </mat-error> -->
                          </mat-form-field>
                          <mat-error *ngIf="f['recurringCount']?.errors?.['limitRepetition']">
                            No es posible repetir un trabajo más de 156 veces
                          </mat-error>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <!-- products -->
            <div class="row"> <!-- *ngIf="formLevel >= 25" -->

              <div class="col-12">
                <h5 class="m-0 pt-3 title-section">
                  Facturación
                  <a [matMenuTriggerFor]="helpFactDialog" (click)="$event.stopPropagation()">
                    <i class="material-icons" style="font-size: 18px; color: #000; cursor: pointer;">help</i>
                  </a>

                  <mat-menu #helpFactDialog="matMenu"
                    class="py-0 px-3 d-flex justify-content-center align-items-center">
                    <ng-container>
                      <span><b class="bold-item">¿Necesitas Ayuda?</b></span><br>
                      <span><b class="bold-item">Por visita:</b> Si selecciona esta opción podra facturar cada trabajo
                        individualmente, al momento de completar la visita o cuando desee.</span><br>
                      <span><b class="bold-item">Trabajo Recurrente:</b> Selecciona esta opción si deseas facturar un
                        monto fijo para un plazo determinado, indepentenmente si las visita no se han completado.</span>
                    </ng-container>
                  </mat-menu>
                </h5>
              </div>

              <div class="col-12" *ngIf="!task?._id">

                <div class="row">

                  <!-- invoicing: how to -->
                  <div class="col-md-6 col-lg-4 mb-2">
                    <div class="row">
                      <div class="col-12">
                        <b>¿Cómo vas a facturar?</b>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div
                            class="col-6 col-md-6 recurring-task-tab cursor-pointer py-1 text-center bordered-element"
                            (click)="setInvoicingAgreement(false)"
                            [ngClass]="{'tab-active': !agreementInvoicing, 'only-option': !recurringTask}">
                            <h5 class="m-0"
                              [ngClass]="{'text-default': !agreementInvoicing, 'text-gray': agreementInvoicing}">
                              <span>Por</span> Visita
                            </h5>
                          </div>

                          <div
                            class="col-6 col-md-6 recurring-task-tab cursor-pointer py-1 text-center bordered-element-right"
                            (click)="setInvoicingAgreement(true)" [ngClass]="{'tab-active': agreementInvoicing}"
                            *ngIf="recurringTask">
                            <h5 class="m-0"
                              [ngClass]="{'text-default': agreementInvoicing, 'text-gray': !agreementInvoicing}">
                              <span>Precio</span> Fijo
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- invoicing: when to -->
                  <!--div class="col-md-4 col-xl-3 mb-2">
                    <b>¿Cuándo vas a facturar?</b> <br>
                    <mat-form-field appearance="outline">
                      <mat-select [disabled]="readOnly">
                        <mat-option *ngFor="let key of taskInvoicingFrequenciesKeys" [value]="freq">{{taskInvoicingFrequencies[key]}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div-->

                  <!-- invoicing: next -->
                  <!--div class="col-md-3 col-xl-3 mb-2">
                    <b>Próxima Factura:</b> <br>
                    {{ lastDayOfMonth | date:'dd/MM/yyyy' }}
                  </div-->
                </div>
              </div>

              <div class="col-md-12">
                <!-- taxPercentage: for compatibility with old tasks -->
                <app-detail-list [items]="task.products" (listChange)="onListChange($event)"
                  [readOnly]="task.status === 'INVOICED'" [pricing]="!task.serviceAgreement?._id"
                  [taxPercentage]="task.taxPercentage ?? 0">
                </app-detail-list>
              </div>
            </div>

            <div class="row font-manax py-3" *ngIf="!agreementInvoicing && !task?.serviceAgreement?._id">
              <div class="col-12">
                <h5 class="m-0 title-section">
                  Gastos
                </h5>
              </div>

              <div class="col-12">
                <!-- taxPercentage: for compatibility with old tasks -->
                <app-detail-list-expenses [items]="safeExpenses" (listChange)="onListChangeExpenses($event)"
                  [readOnly]="task.status === 'INVOICED'" [pricing]="!task.serviceAgreement?._id"
                  [taxPercentage]="task.taxPercentage ?? 0"></app-detail-list-expenses>
              </div>
            </div>

            <!-- dev data: isDeleted && _id -->
            <!--div class="row" *ngIf="task._id && isDev && false">
              <div class="col-3">
                <label>
                  Borrada? <br>
                  <input name="isDeleted" formControlName="isDeleted" type="checkbox" disabled *ngIf="readOnly">
                  <input name="isDeleted" formControlName="isDeleted" type="checkbox" *ngIf="!readOnly">
                </label>
              </div>
              <div class="col-9">
                <mat-form-field appearance="outline" >
                  <input matInput placeholder="Id" type="text" [value]="task._id" readonly>
                </mat-form-field>
              </div>
            </div-->
          </div>

          <!-- comments -->
          <div class="col-md-12" *ngIf="comments?.length > 0">
            <div class="comment-items">
              <span>Comentarios:</span><br>
              <div>
                <div *ngFor="let item of comments" class="m-0 p-0">
                  <b *ngIf="item.worker">{{ item.worker?.firstname }} {{ item.worker?.lastname }}&nbsp;</b>
                  <b *ngIf="!item.worker">{{ item.user?.username }}&nbsp;</b>
                  <b class="small">({{ item.createdAt | date: 'dd/MM/yyyy HH:mm' }}):</b>&nbsp;
                  <span>{{ item.comment }}</span>
                  <ng-container *ngIf="item.attachments?.length > 0">
                    <br>
                    <ng-container *ngFor="let file of item.attachments">
                      <img class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-6 text-primary text-left py-0">
            <div *ngIf="task.quote?.number">
              Generado desde Presupuesto Nro:
              {{ task.quote?.number }}
            </div>
            <div *ngIf="task.deliverynote?.serieAndNumber">
              Incluida en ALBARAN
              {{ task.deliverynote.serieAndNumber}}
            </div>
          </div>

          <div class="col-6 text-primary text-right py-0 justify-self-end">
            <span *ngIf="invoice">
              Incluida en FACTURA
              {{ invoice.serieAndNumber || (invoice.docNumber ? "# " + invoice.docNumber : (invoice.number ? "# " +
              invoice.number : '')) }}
              <span *ngIf="invoice.details && invoice.details.length > 1">. Contiene items adicionales.</span>
            </span>
          </div>
        </div>

        <div class="row">
          <!-- actions -->
          <div class="col-12 task-footer pb-4">
            <div class="row" #bottom>
              <div class="col-12 pt-2">

                <!-- read -->
                <button mat-raised-button type="button" class="m-0 mt-2 mr-2 px-3 pull-left btn btn-outline-danger"
                  (click)="openDeleteTaskConfirm()" *ngIf="readOnly && task?.status != 'CANCELLED'">
                  Eliminar
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  (click)="invoiceTask()"
                  *ngIf="(task?.status == 'COMPLETED') && readOnly && !task?.serviceAgreement?._id">
                  Facturar
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  (click)="openInvoice()" *ngIf="(task?.status == 'INVOICED') && readOnly">
                  Ver&nbsp;Factura
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
                  (click)="openDeliveryNote()"
                  *ngIf="(task?.status == 'COMPLETED' || task?.status == 'INVOICED') && readOnly">
                  <span *ngIf="task.deliverynote">
                    <i class="material-icons">description</i>&nbsp;<span class="d-none d-lg-inline">Ver Albarán</span>
                  </span>
                  <span *ngIf="!task.deliverynote">
                    <i class="material-icons">description</i>&nbsp;<span class="d-none d-lg-inline">Crear Albarán</span>
                  </span>
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  (click)="setStatusCompleted()"
                  *ngIf="(task?.status == 'SCHEDULED' || task?.status == 'ONGOING') && readOnly">
                  Completar
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  (click)="setStatus('SCHEDULED'); scheduling = true"
                  *ngIf="(task?.status == 'OPEN' || task?.status == 'QUOTED') && readOnly">
                  Agendar
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  (click)="setStatus('QUOTED')" *ngIf="(task?.status == 'OPEN') && readOnly">
                  Presupuestar
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
                  (click)="openDuplicateTaskModal(task)" *ngIf="readOnly">
                  <i class="material-icons">difference</i>&nbsp;<span class="d-none d-lg-inline">Duplicar</span>
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
                  (click)="openShareModal()" *ngIf="(formLevel >= 25) && readOnly">
                  <i class="material-icons">share</i>&nbsp;<span class="d-none d-lg-inline">Compartir</span>
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
                  (click)="openMovementsModal()" *ngIf="formLevel > 25 && readOnly">
                  <i class="material-icons">access_time</i>&nbsp;<span class="d-none d-lg-inline">Fichajes</span>
                </button>

                <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
                  (click)="openNewCommentModal()" *ngIf="formLevel > 25 && readOnly">
                  <i class="material-icons">forum</i>&nbsp;Comentario<span class="d-none d-lg-inline"> / Foto</span>
                </button>

                <!-- edit -->
                <button mat-raised-button type="button" class="m-0 mt-2 mr-2 px-3 pull-left btn btn-outline"
                  (click)="cancelSubmit(); scheduling = false" *ngIf="!readOnly">
                  Cancelar
                </button>

                <!--button mat-raised-button [disabled]="saving" type="button"
                  [hidden]="!(task?.status == 'OPEN' || task?.status == 'QUOTED')"
                  class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax" *ngIf="!readOnly" [matMenuTriggerFor]="moreMenu">
                  Guardar y... <i class="material-icons">expand_more</i>
                </button>
                <mat-menu #moreMenu="matMenu">
                  <button mat-menu-item (click)="onSubmit('QUOTED')" *ngIf="(task?.status == 'OPEN')">
                    <span>Presupuestar</span>
                  </button>
                  <button mat-menu-item (click)="onSubmit('SCHEDULED'); scheduling = true"
                    *ngIf="(task?.status == 'OPEN' || task?.status == 'QUOTED')">
                    <span>Agendar</span>
                  </button>
                </mat-menu-->

                <button mat-raised-button type="submit" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  *ngIf="!readOnly && !(task?.status == 'SCHEDULED' || task?.status == 'ONGOING' || task?.status == 'INVOICED')">
                  <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
                  Guardar
                </button>
                <!-- boton de programado para adelante -->
                <button mat-raised-button type="submit" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-manax"
                  *ngIf="!readOnly && (task?.status == 'SCHEDULED' || task?.status == 'ONGOING')">
                  <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>